import { useMemo } from "react"

import type { Product, Transfer, TransferLot } from "@/graphql/codegen/graphql"

interface UseTransferLookupsReturn {
  productsByReferenceNbr: Map<number, Product>
  transferLotsById: Map<string, TransferLot>
}

export const useTransferLookups = (transfer: Transfer): UseTransferLookupsReturn =>
  useMemo(
    () => ({
      productsByReferenceNbr: new Map(
        transfer.products.flatMap(({ product, pallets }) => pallets.map((pallet) => [pallet.referenceNbr, product]))
      ),
      transferLotsById: new Map(
        transfer.products.flatMap(({ pallets }) =>
          pallets.flatMap(({ lots }) => lots.map((lot) => [lot.transferLotId, lot]))
        )
      ),
    }),
    [transfer]
  )
